import { forwardRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import componentStyles from "assets/theme/components/dropdowns/notifications-dropdown.js";

const useStyles = makeStyles(componentStyles);


export const getRedirectLink = (routesUser, item) => {
  let viewToRedirect;

  routesUser?.forEach((route) => {
    if (!viewToRedirect) {
      viewToRedirect = route.views.find((view) => {
        return view.name === item.NomeMenu;
      });
    }
  });

  if (viewToRedirect) {
    return viewToRedirect.layout + viewToRedirect.path;
  } else {
    return "";
  }
};

export const filterRepeatedMenus = (options) => {
  const optionsToFilter = options || [];

  return optionsToFilter.filter((option, index) => {
    return (
      optionsToFilter.findIndex((optionToFind) => {
        return optionToFind.IdMenu === option.IdMenu;
      }) === index
    );
  });
};

export const updatedFavoriteItems = (items, itemToUpdate) => {
  return (
    items?.map((item) => {
      if (item.IdMenu === itemToUpdate) {
        return { ...item, Favorito: !item.Favorito };
      }

      return item;
    }) || []
  );
};

export const ItemText = forwardRef(({ text }, ref) => {
  const classes = useStyles();

  return (
    <Typography
      ref={ref}
      variant="h4"
      component="h4"
      className={classes.typographyH4}
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </Typography>
  );
});

ItemText.displayName = "ItemText";
